<template>
  <div class='selectNumberAccesses'>
    <b-modal
      id="calculate-subordinate-users"
      header-bg-variant="primary"
      header-text-variant="light"
      ref="calculate-subordinate-users"
      hide-footer
      hide-header
      size='lg'
    >
      <div class='modal-font-family p-1' >
        <div class='w-100 d-flex justify-content-end'>
          <a @click='hideModalCalculateSubordinateUsers()' class='d-flex align-items-center btn_close'>
            <b-icon
              class='ml-1 cursor-pointer'
              font-scale='2'
              icon='x'
              color='#022245'
            >
            </b-icon>
          </a>
        </div>

        <div class="d-flex align-content-center cursor-pointer mb-3">
          <img height="25" width="25" alt="Ho Facil logo" src="../../../assets/images/light.png" />
          <strong>Como é calculado o preço do usuário subordinado?</strong>
        </div>
        <h5 class="mb-2"><strong>Fórmula:</strong></h5>
        <p><strong>Preço da compra</strong> = (1 - B) × C × D</p>

        <p><strong>Onde:</strong></p>
        <ul class="ml-4">
          <li><strong>A</strong> = Valor pago (em R$) pela contratação do usuário Master</li>
          <li><strong>B</strong> = Percentual de desconto, conforme a quantidade de usuários subordinados</li>
          <li><strong>C</strong> = Quantidade de dias restantes no plano do usuário Master</li>
          <li><strong>D</strong> = Custo diário do usuário subordinado</li>
        </ul>

        <h5 class="mt-5"><strong>Cálculo de D (custo diário):</strong></h5>
        <p><strong>D</strong> = A ÷ (365 × número de anos de acesso contratado pelo usuário Master)</p>
      </div>
    </b-modal>
    <div style='min-height: 250px'>
      <div class='my-3' v-if='numberExistingUsers < maximumAmountOfHitsCanBePurchased'>
        <p class='numberAccesses'>
          Selecione a quantidade adicional de acessos que você pretende contratar para seus colaboradores (descontos a
          partir de 10%):
        </p>

        <div class='group'>
          <b-form-select
            v-model='additionalAccessQuantity'
            :options='employees'
            class='mb-3'
            style='height: 50px'
            value-field='key'
            text-field='value'
            @change='calculateTotal()'
          >
            <template #first>
              <b-form-select-option :value='0' disabled>Selecione a quantidade de colaboradores</b-form-select-option>
            </template>
          </b-form-select>

          <div v-if='additionalAccessQuantity > 0'>
            <div
              style="width: fit-content"
              @mouseover="showModalCalculateSubordinateUsers()"
              @mouseout="hideModalCalculateSubordinateUsers()"
              class="d-flex align-content-center cursor-pointer"
            >
              <img height="25" width="25" alt="Ho Facil logo" src="../../../assets/images/light.png" />
              <strong>Como é calculado o preço do usuário subordinado?</strong>

              <b-icon
                style='margin-bottom: -1px'
                class='ml-1 mt-1'
                font-scale="1.2"
                icon="info-circle-fill"
                variant="info"
              >
              </b-icon>
            </div>
          </div>

          <div class='p-2' v-if='additionalAccessQuantity > 0'>
            <ul class="ml-3">
              <li>
                <strong>Usuário Master:</strong>
                <ul class="ml-4">
                  <li>
                    Preço que foi pago pelo usuário master:
                    <span>
                        {{
                        formatRealCurrent(paidReferenceValue)
                      }}
                      </span>
                  </li>
                </ul>
              </li>
              <li class="mt-1">
                <strong>Usuário subordinado:</strong>
                <ul class="ml-4">
                  <li>Quantidade {{ additionalAccessQuantity }} unidade(s)</li>
                  <li>Dia(s) restante de vigência do plano {{ diasRestanteVencimentoPlano }}</li>
                  <li>
                    Desconto aplicado somente aos usuários subordinados: {{ percentage(additionalAccessQuantity + numberExistingUsers) }}%
                  </li>
                  <li>
                    Preço: <span style="text-decoration: line-through; color:#bc0000;">
                    {{formatRealCurrent(paidReferenceValue * additionalAccessQuantity)}}
                  </span>
                    <span>&nbsp;&nbsp; {{formatRealCurrent(parseFloat(totalPrice))}}</span>
                  </li>
                </ul>
              </li>

              <li class="mt-1">
                <strong>Total a pagar:</strong>
                <ul class="ml-4">
                  <li>
                    <strong>Preço:
                      {{formatRealCurrent(Number(totalPrice))}}
                    </strong>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div v-else>
        O plano {{this.user.plan.plan === 'AN1HO' ? 'Anual' : 'Promocional'}}
        adquiro no dia {{ formatDate(this.user.plan.createdAt)}}
        pode comprar até {{maximumAmountOfHitsCanBePurchased}} acessos.

        <h6 class='mt-2'><strong>Acessos comprados:</strong></h6>

        <div v-for='(item, i) in listPurchasedHits' :key="i">
          <p style='border-top: 1px solid #ccc'>
            <strong>Data da compra: </strong> <span>{{formatDate(item.createdAt)}}</span><br/>
            <strong>Acessos comprados: </strong> <span>{{item.amountPurchased}}</span><br/>
            <strong>Acessos restantes: </strong> <span>{{item.remainingAmount}}</span><br/>
            <strong>Acessar fatura: </strong> <a :href='item.invoiceUrl' target='_blank'>Clique aqui para acessar</a>
          </p>
        </div>
        <h6 class='mt-2'>
          <strong>Total de acessos comprados: </strong>
          <span>{{listPurchasedHits.reduce((acumulator, access) => acumulator + access.amountPurchased, 0)}}</span>
        </h6>
      </div>
    </div>

    <b-row>
      <b-col cols='12'>
        <b-overlay
          :show='loading'
          rounded
          opacity='0.6'
          spinner-small
          spinner-variant='primary'
          class='d-inline-block w-100'
          v-if='numberExistingUsers < maximumAmountOfHitsCanBePurchased'
        >
          <base-button
            :disabled='additionalAccessQuantity <= 0'
            block
            @click='next()'
          >
            Próximo
          </base-button>
        </b-overlay>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import { formatRealCurrent } from '@/utils/format'
import { required } from '@/utils/validators'
import useVuelidate from '@vuelidate/core'
import format from 'date-fns/esm/format/index'

export default {
  name: 'SelectNumberAccesses',
  setup() {
    return { v$: useVuelidate() }
  },
  props: {},

  async mounted() {
    this.planId = this.$route.params.planId
    await this.purchasedHits(this.planId)
    const { paidReferenceValue } = await this.handleAmountPaidPlan(this.planId)
    const { numberExistingUsers } = await this.handleAmountAccessCollaboratorPaid(this.planId)
    await this.handleSetNumberExistingUsers(numberExistingUsers)
    await this.handleSetPaidReferenceValue(paidReferenceValue)
    this.additionalAccessQuantity = this.getAdditionalAccessQuantity
    this.generateOptionsNumberEmployees()
    await this.calculateTotal()
    await this.handleSetPlanId(this.planId)
  },
  created() {
    const breadcrumb = {
      page: 'Comprar acessos',
      subPage: {
        name: 'Comprar acessos',
        active: false
      },
      tabs: [
        {
          name: 'Selecionar quantidade de acessos',
          active: true
        }
      ]
    }
    this.setBreadcrumb(breadcrumb)
  },
  data() {
    return {
      nextComponent: 'BillingDataAccess',
      planId: '',
      loading: false,
      access: [],
      additionalUserDiscount: 0.01,
      baseDiscount: 0.09,
      maximumDiscount: 0.19,
      diasRestanteVencimentoPlano: 0,
      employees: [],
      diasEmUmAno: 365,
      additionalAccessQuantity: 0,
      maximumAmountOfHitsCanBePurchased: 10,
      listPurchasedHits: []
    }
  },
  computed: {
    ...mapGetters('user', {
      user: 'current'
    }),
    ...mapGetters('checkoutAccess', {
      paidReferenceValue: 'paidReferenceValue',
      getAdditionalAccessQuantity: 'additionalAccessQuantity',
      numberExistingUsers: 'numberExistingUsers',
      totalPrice: 'totalPrice'
    })
  },
  validations() {
    return {
      additionalAccessQuantity: {}
    }
  },
  methods: {
    ...mapActions('userPlans', {
      handleAmountPaidPlan: 'handleAmountPaidPlan'
    }),
    ...mapActions('checkoutAccess', {
      handleSetPaidReferenceValue: 'handleSetPaidReferenceValue',
      handleSetNumberExistingUsers: 'handleSetNumberExistingUsers',
      handleSetTotalPrice: 'handleSetTotalPrice',
      handleSetadditionalAccessQuantity: 'handleSetadditionalAccessQuantity',
      handleSetPlanId: 'handleSetPlanId'
    }),
    ...mapActions('acessCollaborator', {
      handleAmountAccessCollaboratorPaid: 'handleAmountAccessCollaboratorPaid',
      handleAmountAccessPlan: 'handleAmountAccessPlan',
    }),
    ...mapActions('breadcrumb', {
      setBreadcrumb: 'setBreadcrumb'
    }),
    showModalCalculateSubordinateUsers(){
      this.$bvModal.show('calculate-subordinate-users')
    },

    hideModalCalculateSubordinateUsers(){
      this.$bvModal.hide('calculate-subordinate-users')
    },

    async purchasedHits() {
      try {
        const {accessCollaborator} = await this.handleAmountAccessPlan(this.planId)
        this.listPurchasedHits = accessCollaborator
      } catch (e) {

      }
    },

    formatDate(date) {
      return format(new Date(date), 'dd/MM/yyyy')
    },

    formatRealCurrent,
    generateOptionsNumberEmployees() {
      for (let employee = 1; employee <= (this.maximumAmountOfHitsCanBePurchased - this.numberExistingUsers); employee++) {
        this.employees.push({
          key: employee,
          value: `${employee} ${employee > 1 ? 'colaboradores adicionais ' : 'colaborador adicional'} `
        })
      }
    },

    percentage(quantidadeColaboradores) {
      switch (quantidadeColaboradores) {
        case 1: {
          return 10
        }
        case 2: {
          return 11
        }
        case 3: {
          return 12
        }
        case 4: {
          return 13
        }
        case 5: {
          return 14
        }
        case 6: {
          return 15
        }
        case 7: {
          return 16
        }
        case 8: {
          return 17
        }
        case 9: {
          return 18
        }
        case 10: {
          return 19
        }
      }
    },

    async calculateTotal() {
      this.access = []

      await this.handleSetadditionalAccessQuantity(this.additionalAccessQuantity)
      for (let i = 1; i <= this.additionalAccessQuantity; i++) {
        const percentage = this.percentage(i)
        this.access.push(
          {
            quantidadeAcesso: i,
            discount: percentage.toString().replace('.', ',')
          }
        )
      }
      const quantidadeDiasRestanteDataVencimentoPlano = this.calcularQuantidadeDiasRestanteDataVencimentoPlano(new Date(this.user.plan.dueDate), new Date(this.user.currentDate))
      const valorReferanciaParaComprarAcessos = this.calculoValorReferanciaParaComprarAcessos(quantidadeDiasRestanteDataVencimentoPlano)

      const total = Number(this.calcularTotal(valorReferanciaParaComprarAcessos))
      await this.handleSetTotalPrice(total)
    },

    calculoValorReferanciaParaComprarAcessos(quantidadeDias) {
      const precoPorDia = Number(this.paidReferenceValue) / Number(this.diasEmUmAno)
      return precoPorDia * quantidadeDias
    },

    calcularQuantidadeDiasRestanteDataVencimentoPlano(dataValidadeUsuarioMaster, dataCompraUsuarioSubordinado) {
      let timeContractYearsAnnualPlan = 1
      if(this.user.plan && this.user.plan.timeContractYearsAnnualPlan){
        timeContractYearsAnnualPlan = Number(this.user.plan.timeContractYearsAnnualPlan)

      }
      let diasRestanteVencimentoPlano = Math.floor(moment.duration(moment(dataValidadeUsuarioMaster).diff(moment(dataCompraUsuarioSubordinado))).asDays())
      this.diasRestanteVencimentoPlano = diasRestanteVencimentoPlano
      /*if (diasRestanteVencimentoPlano > (this.diasEmUmAno * timeContractYearsAnnualPlan)) {
        diasRestanteVencimentoPlano = (this.diasEmUmAno * timeContractYearsAnnualPlan)
      }*/
      return diasRestanteVencimentoPlano
    },

    calcularTotal(precoNoCheckout) {
      this.additionalUserDiscount = 0.01
      this.baseDiscount = 0.09
      this.additionalUserDiscount *= (this.numberExistingUsers + this.additionalAccessQuantity)
      this.baseDiscount += this.additionalUserDiscount
      if (this.baseDiscount > this.maximumDiscount) {
        this.baseDiscount = this.maximumDiscount
      }
      let total = 0
      for (let i = 1; i <= this.additionalAccessQuantity; i++) {
        const precoPorAcesso = Number(precoNoCheckout) * (1 - this.baseDiscount)
        total += Number(precoPorAcesso)
      }
      return total
    },

    async next() {
      this.$emit('next-step')
      this.$emit('set-component', this.nextComponent)
    }
  },
  watch: {}

}
</script>
<style>
.custom-tooltip > .tooltip-inner {
  background: #000000;
  max-width: 800px !important;
  width: 600px !important;
}
</style>
<style lang='scss' scoped>
.selectNumberAccesses {
  background: #FFFFFF;
  border-radius: 10px;
}

.loading {
  position: absolute;
  margin-left: -30px;
  margin-top: 12px;
  width: 1.5rem;
  height: 1.5rem;
}

.btn-radio {
  display: flex;
  flex-direction: row;

  .form-radio {
    padding: 5px;
    cursor: pointer !important;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .hits_value {
      font-style: normal;
      font-weight: 700;
      font-size: 14px;
      line-height: 18px;
      color: #04A8F3;
    }

    .hits_description {
      font-style: normal;
      font-weight: 400;
      font-size: 13px;
      line-height: 24px;
      color: #262626;
    }
  }
}

.hits_select {
  border: 1px solid #04A8F3;
  padding: 5px;
  border-radius: 5px
}

.hits_no_select {
  border: 1px solid transparent;
  padding: 5px;
  border-radius: 5px
}

.billing-data {
  display: flex;
  flex-direction: column;
  gap: 8px;

  .title_options {
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    color: #022245;
  }

  label {
    font-size: 18px;
    font-weight: 700;
  }

  .use-account-data {
    span {
      font-size: 18px;
    }

    .buttons {
      display: flex;
      gap: 8px;
    }
  }

  .address {
    display: flex;
    flex-direction: column;
    gap: 4px;

    h2 {
      font-size: 22px;
      font-weight: bold;
      text-align: center;
    }

    .group {
      display: grid;
      grid-template-columns:  60% 38%;
      gap: 2%;
    }
  }
}

.numberAccesses {
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #022245;
}
</style>
